import APIClient from '@/shared/http/clients/api'

const resourceName = 'gedArquivoHistorico'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAll = (fileID, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/arquivo/${fileID}`, data, config)

const GedFileHistoryRepository = {
  GetAll
}

export default GedFileHistoryRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/gedfilehistory.js